import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';

/*
  If `closeModal` is used as a handler (e.g. `onClick={closeModal}`) the action creator
  receives the Proxy/SyntheticEvent as `data`. That data is returned as part of the action
  which is then dispatched.

    Fun Fact #1: Dispatching is async (this shouldn't be news)
    Fun Fact #2: React only has one synthetic event that it keeps reusing (wait, what?)

  The "event" passed to the `closeModal` action-creator will still exist when the
  dispatch gets handled by the saga but it will no longer represent the same "event".

  If React detects that an event is being referenced asynchronously it logs a warning...
    "Warning: This synthetic event is reused for performance reasons. [...]"

  If that event is now part of your redux store... that warning will spam your console.

  So, rather than make two `closeModal`s (with/without data) or make everyone wrap `closeModal`
  in an anonymous function (e.g. `onClick={() => closeModal()}`) we ignore anthing that
  looks like an Event.
*/

// React Proxy/SyntheticEvent ducktype
function looksLikeASyntheticEvent(e) {
  return _isObject(e) && e.nativeEvent && e.nativeEvent instanceof Event;
}

export const OPEN_MODAL = 'OPEN_MODAL';
export const openModal = (name, props = {}) => {
  // see above comment
  if (_isNil(props) || props instanceof Event || looksLikeASyntheticEvent(props)) {
    return { type: OPEN_MODAL, name };
  }
  return { type: OPEN_MODAL, name, props };
};

export const CLOSE_MODAL = 'CLOSE_MODAL';
export const closeModal = data => {
  // see above comment
  if (
    _isNil(data) || // `data` can be a falsy value
    data instanceof Event ||
    looksLikeASyntheticEvent(data)
  ) {
    return { type: CLOSE_MODAL };
  }

  return { type: CLOSE_MODAL, data };
};

const INITIAL_STATE = {};

function newStateWithAllClosed(state) {
  const newState = { ...state };

  Object.keys(newState).forEach(modalName => {
    newState[modalName] = { ...newState[modalName], isOpen: false, props: {} };
  });

  return newState;
}

export default (state = INITIAL_STATE, action = {}) => {
  const { type, name, props } = action;

  switch (type) {
    case OPEN_MODAL:
      return {
        ...newStateWithAllClosed(state),
        [name]: {
          isOpen: true,
          props,
        },
      };

    case CLOSE_MODAL:
      return {
        ...newStateWithAllClosed(state),
      };

    default:
      return state;
  }
};
